import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { colors, radii } from '@/lib/theme';

const pulse = keyframes`
	0%, 100% { opacity: 1; }
	50% { opacity: 0.45; }
`;

/**
 * A grey block that pulses while content loads. Size it with `width`,
 * `height` or `aspectRatio` props (any CSS length).
 */
export const Skeleton = styled.div<{
	width?: string;
	height?: string;
	aspectRatio?: string;
	round?: boolean;
}>`
	background-color: ${colors.LM_NU20};
	border-radius: ${({ round }) => (round ? '999px' : radii.radii30)};
	animation: ${pulse} 1.8s ease-in-out infinite;
	width: ${({ width = '100%' }) => width};
	${({ height }) => height && `height: ${height};`}
	${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
`;
